export enum FinancingContractType {
    UNSPECIFIED = 'unspecified',
    FINANCIAL_LEASING = 'financial-leasing',
    SERVICE_LEASING = 'service-leasing',
    CREDIT_LEASING = 'credit-leasing',
    OPEN_CALCULATION_SERVICE_LEASING = 'open-calculation-service-leasing',
    PART_PAYMENT = 'part-payment',
    CUSTOMER_OWNED_VEHICLE = 'customer-owned-vehicle',
    CUSTOMER_EMPLOYEE_VEHICLE = 'customer-employee-vehicle',
    MINILEASING = 'minileasing',
}
